var _g, _path, _path2, _ellipse, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 72C7.58179 72 4.00006 68.4183 4.00006 64L4.00006 8.06471C4.00006 3.64643 7.58178 0.0647124 12.0001 0.0647122L70.4407 0.0647096L70.4407 72L12.0001 72Z",
    fill: "#EF4F6E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4968 68.5194C11.0785 68.5194 7.49683 64.9377 7.49683 60.5194L7.49682 11.5456C7.49682 7.12732 11.0785 3.5456 15.4968 3.5456L70.4405 3.5456L70.4406 68.5194L15.4968 68.5194Z",
    fill: "#FE6784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5759 4.43325C22.5577 3.91811 24.5623 5.77715 25.2804 6.57215C16.5566 5.13741 13.4414 8.54142 12.7913 8.50703C10.4475 8.38305 11.3487 5.07716 17.5759 4.43325Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.16478,
    cy: 0.580546,
    rx: 1.16478,
    ry: 0.580546,
    transform: "matrix(0.918912 0.394463 -0.397551 0.91758 26.7532 5.8573)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0049 35.5518C21.0049 31.5571 20.9971 27.5537 21.0049 23.5551C21.0118 20.8367 22.7962 18.6552 25.443 18.1116C25.8143 18.0388 26.1921 18.0029 26.5706 18.0044C34.7771 17.9985 42.9843 17.9985 51.1921 18.0044C52.3236 18.0044 52.9961 18.666 52.9961 19.7913C52.9961 27.7534 52.9961 35.7152 52.9961 43.6766C52.9961 44.8458 52.3246 45.4684 51.0854 45.4684C42.9885 45.4684 34.8913 45.4684 26.7937 45.4684C26.1898 45.4684 25.628 45.56 25.1454 45.9487C24.7932 46.226 24.5344 46.6037 24.4036 47.0313C24.2728 47.4589 24.2761 47.916 24.4132 48.3416C24.5574 48.7712 24.8295 49.1468 25.1933 49.4187C25.5572 49.6905 25.9956 49.8457 26.4502 49.8635C26.5843 49.8703 26.7184 49.8635 26.8535 49.8635C34.9386 49.8635 43.0237 49.8619 51.1089 49.8586C51.9047 49.8586 52.5262 50.1061 52.862 50.8534C52.9688 51.0969 53.0148 51.3624 52.9959 51.6274C52.9771 51.8924 52.8941 52.1488 52.7539 52.3749C52.6137 52.6009 52.4205 52.7897 52.191 52.9252C51.9614 53.0607 51.7023 53.1388 51.4358 53.1528C51.3379 53.1586 51.24 53.1528 51.1422 53.1528C42.9715 53.1528 34.8009 53.1528 26.6303 53.1528C23.7711 53.1528 21.5237 51.2607 21.0568 48.4576C21.0104 48.1082 20.9924 47.7556 21.003 47.4034C21.0004 43.4528 21.001 39.5023 21.0049 35.5518ZM37.0304 22.9296C36.7279 22.9627 36.4235 22.9831 36.123 23.027C33.8149 23.3992 32.0041 25.5378 32.0315 27.8498C32.0422 28.754 32.7166 29.4828 33.5849 29.5227C34.5275 29.5646 35.2489 28.9313 35.336 27.9882C35.3459 27.8426 35.3632 27.6975 35.3879 27.5536C35.4602 27.1963 35.6501 26.8731 35.9276 26.6352C36.205 26.3972 36.5542 26.2581 36.92 26.2398C37.2858 26.2214 37.6472 26.325 37.9473 26.534C38.2474 26.743 38.4689 27.0455 38.5769 27.3939C38.6943 27.7503 38.6834 28.1364 38.546 28.4857C38.4087 28.835 38.1535 29.1259 37.8242 29.3084C36.6104 30.0187 35.8323 31.0446 35.5053 32.3989C35.337 33.0965 35.2176 33.8156 35.4672 34.519C35.5985 34.8699 35.8475 35.1648 36.1721 35.3539C36.4968 35.5429 36.877 35.6146 37.2486 35.5567C38.0846 35.4222 38.6572 34.7694 38.6533 33.8614C38.6533 33.0293 38.9675 32.4593 39.6977 32.0102C41.5438 30.878 42.3787 28.5825 41.7718 26.5092C41.4685 25.4871 40.8447 24.5884 39.9917 23.9443C39.1386 23.3003 38.1009 22.9447 37.0304 22.9296ZM37.0304 37.252C36.0936 37.2442 35.3663 37.934 35.3507 38.8538C35.3529 39.2854 35.525 39.699 35.8302 40.0056C36.1354 40.3123 36.5493 40.4876 36.9829 40.4938C37.4165 40.5001 37.8352 40.3368 38.1492 40.0391C38.4632 39.7413 38.6473 39.3329 38.6621 38.9015C38.6665 38.6854 38.6274 38.4707 38.5471 38.2699C38.4667 38.0691 38.3468 37.8864 38.1943 37.7325C38.0419 37.5787 37.86 37.4568 37.6594 37.3741C37.4588 37.2914 37.2436 37.2495 37.0264 37.251L37.0304 37.252Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1056",
    x: 0.0000610352,
    y: 0.0646973,
    width: 74.4406,
    height: 79.9353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1056",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideSheet);
export default __webpack_public_path__ + "static/media/guide-sheet.567c53489f0200ba35136d13185a38da.svg";
export { ForwardRef as ReactComponent };